import React from 'react';

import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

function PendingApplicationDialog(props) {
  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Request Under Process
      </DialogTitle>
      <DialogContent style={{maxWidth: 500}}>
        <DialogContentText id="alert-dialog-description">
          You have already submitted an application for student identity card replacement. You may check the submitted application in the “Application History” page.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.onClick}>Application History</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PendingApplicationDialog;
